module.exports = __webpack_public_path__ + "img/logo.f05f1166.png";